import {
  CSV_FORMULA_TRIGGER,
  CSV_PLAIN_NUMBER,
} from '@/components/lemmala-design-system/table/consts'

export const escapeCsvFormula = <T>(value: T): T | string => {
  if (typeof value !== 'string' || value === '-' || CSV_PLAIN_NUMBER.test(value)) return value
  return CSV_FORMULA_TRIGGER.test(value) ? `'${value}` : value
}
